
      if (import.meta.env.VITE_NEWRELIC_SCRIPT) {
        const nr = document.createElement("script");
        nr.async = true;
        nr.src = "/" + import.meta.env.VITE_NEWRELIC_SCRIPT;
        document.head.appendChild(nr);
      }

      if (import.meta.env.VITE_ENABLE_ANALYTICS === "true") {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-QPFYEWD7TC";
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          dataLayer.push(arguments);
        };
      } else {
        window.gtag = function () {
          console.info("gtag", Array.prototype.slice.call(arguments));
        };
      }
      window.gtag("js", new Date());
      // J
      window.gtag("config", "G-QPFYEWD7TC");
      // AW Conversion Tag
      window.gtag("config", "AW-18227189643");
      // Track conversion function
      window.trackConversion = function (transaction_id) {
        window.gtag("event", "conversion_event_purchase", {
          transaction_id: transaction_id,
        });
      };
    